
define(
	'Code25.CaterpartsGlobal.WhatsApp'
	, [
		"Handlebars", "Utils", "Code25.CaterpartsGlobal.WhatsApp.View"
	]
	, function (
		Handlebars, Utils, Code25CaterpartsGlobalWhatsAppView
	) {
		'use strict';

		return {
			mount: function mount(container) {

				var layout = container.getComponent('Layout');
				layout.registerView('WhatsApp', function () {
					return new Code25CaterpartsGlobalWhatsAppView({ application: container });
				});

			}
		};

	});
